import { render, staticRenderFns } from "./bottom_four.vue?vue&type=template&id=6d0cb008&scoped=true&"
import script from "./bottom_four.vue?vue&type=script&lang=js&"
export * from "./bottom_four.vue?vue&type=script&lang=js&"
import style0 from "./bottom_four.vue?vue&type=style&index=0&id=6d0cb008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0cb008",
  null
  
)

export default component.exports